import { SIDEBAR_COMMON_STYLE } from "../../siteInfo/SiteStyle";
const SNSList = {
  SNSListContainer: {
    width: "90%",
    maxWidth: 375,
    marginRight: "auto",
    marginLeft: "auto",
    marginBottom: 18,
    background: "white",
    borderRadius: 3,
    overflow: "hidden",
  },
  snsHeader: {
    color: SIDEBAR_COMMON_STYLE.color,
    fontSize: SIDEBAR_COMMON_STYLE.headerFontSize,
    backgroundColor: SIDEBAR_COMMON_STYLE.mainColor,
    paddingTop: 9,
    paddingBottom: 9,
    textAlign: "center",
  },
  icons: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignContent: "center",
    padding: 9,
  },
};
export default SNSList;
